import { NgModule } from '@angular/core';
import { RoundPipe } from '../pipes/round.pipe';
import { SeasonEnabled, SeasonStates, SeasonStateList } from '../pipes/season.pipe';
import { MatIconModule, MatButtonModule, MatDialogModule, MatTooltipModule } from '@angular/material';

@NgModule({
    imports: [
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatTooltipModule
    ],
    declarations: [
        RoundPipe,
        SeasonEnabled,
        SeasonStates,
        SeasonStateList
    ],
    exports: [
        RoundPipe,
        SeasonEnabled,
        SeasonStates,
        SeasonStateList,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatTooltipModule
    ],
})
export class LayoutComponentsModule { }
